import "react-quill/dist/quill.snow.css";
import "./index.css"
import ReactQuill from 'react-quill';

const CustomEditor = ({
  value,
  onChange,
  height = "250px"
}) => {
  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={onChange}
      className="custom-editor"
      style={{
        height: height, // 42px accounts for the toolbar height
        marginBottom: "44px",
      }}
    />
  );
}
export default CustomEditor;